import MovieThumbnail from './MovieThumbnail';

export default MovieThumbnail;
